import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=685f1060&"
import script from "./productManage.vue?vue&type=script&lang=js&"
export * from "./productManage.vue?vue&type=script&lang=js&"
import style0 from "./productManage.vue?vue&type=style&index=0&id=685f1060&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports